import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { ButtonBase, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useRptMain } from '../../../St/Reviews/UseStyle';
import { QRCodeCanvas } from "qrcode.react";
import { useStylesCashNotax } from "../CashierNoTax/BodyCash";
// import "../AFReadyDisigen/riyals.css"

function TotalsCashair(props) {
    const { found, inv, sta, locInv, onUnmountComplete } = props;
    const { t } = useTranslation(["forms", "translation"]);
    const clasm = useRptMain();
    const styleE = {
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "0.8rem",
        color: "black",
        fontWeight: "bold",
    };

    const styleNum = {
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "0.9rem",
        color: "black",
        fontWeight: "bold",
    };


    const styleA = {

        textAlign: "center",
        fontSize: "0.8rem",
        color: "black",
        fontWeight: "bold",
    };
    const classes = useStylesCashNotax();

    useEffect(() => {
        setTimeout(async () => {
            onUnmountComplete();
        }, 300);
    }, []);
    return (
        <Grid item container >
            {locInv?.post != 2 && <>
                <Grid item container style={{ direction: "rtl", fontFamily: "Amiri-Regular", marginBottom: "0.5rem", marginTop: "0.7rem" }}>
                    <Grid item xs={7} style={styleE}>
                        {"الاجمالي قبل الضريبة"}
                    </Grid>
                    <Grid item xs={5} style={styleNum}>
                        {((sta?.tot?.tot_net - sta?.tot?.amountOfVat + sta?.tot?.discount) - parseFloat(sta?.tot?.tab3Vat ?? 0))?.toFixed(2)}
                    </Grid>
                    <Grid item xs={7} style={styleE}>
                        {"Discount مجموع الخصومات"}
                    </Grid>
                    <Grid item xs={5} style={styleNum}>
                        {sta?.tot?.discount?.toFixed(2)}
                    </Grid>
                    <Grid item xs={7} style={styleE}>
                        {"الاجمالي الخاضع للضريبة"}
                    </Grid>
                    <Grid item xs={5} style={styleNum}>
                        {((sta?.tot?.tot_net - sta?.tot?.amountOfVat) - parseFloat(sta?.tot?.tab3Vat ?? 0))?.toFixed(2)}
                    </Grid>
                    {parseFloat(sta?.tot.tab3Vat) > 0 &&
                        (
                            <>
                                <Grid item xs={7} style={styleE}>
                                    {"مجموع ضريبة التبغ"}
                                </Grid>
                                <Grid item xs={5} style={styleNum}>
                                    {sta?.tot?.tab3Vat?.toFixed(2)}
                                </Grid>
                            </>
                        )}
                    <Grid item xs={7} style={styleE}>
                        {"مجموع ضريبة القيمة المضافة"} {"("}{inv.tax}{"%"}{")"}
                    </Grid>
                    <Grid item xs={5} style={styleNum}>
                        {sta?.tot?.amountOfVat?.toFixed(2)}
                    </Grid>

                    <Grid item xs={7} style={styleE}>
                        {"الاجمالي يشمل القيمة المضافة"}
                    </Grid>
                    <Grid item xs={5} style={styleNum}>
                        {sta?.tot?.amountWithVat?.toFixed(2)}
                    </Grid>
                </Grid>
                <Grid item className={classes.checStyl6} style={{ fontWeight: "bold", fontSize: "0.8rem" }} xs={6}>
                    {" متبقي"}
                    {"\n"}
                    {sta.tot?.inv_type_name == "نقدية"
                        ? 0
                        : sta?.tot?.tot_net?.toFixed(2) - sta?.tot?.paid}
                </Grid>
                <Grid item className={classes.checStyl6} style={{ fontWeight: "bold", fontSize: "0.8rem" }} xs={6}>
                    {" مدفوع"}
                    {"\n"}
                    {sta?.tot?.inv_type_name == "نقدية"
                        ? sta?.tot?.tot_net?.toFixed(2)
                        : sta?.tot?.paid}
                </Grid>
            </>}
            <Grid item xs={12}>
                <Typography className={clasm.mincntr} style={styleA}>
                    {inv?.notes?.toString()?.startsWith('Receipt voucher') && inv?.notes}</Typography>
            </Grid>

            {locInv?.post != 2 && <Grid item xs={12} style={{ textAlign: "center" }} spacing={0} >
                {(locInv?.Step_inv2 && sta.tot?.ZatcaQR) ?
                    (
                        <ButtonBase style={{ borderRadius: "3", margin: 0, padding: 0, marginTop: 0 }}>
                            {
                                <QRCodeCanvas value={sta.tot?.ZatcaQR}
                                    size={220}
                                    level="M"
                                    includeMargin={true}
                                    style={{ imageRendering: "pixelated" }} />
                            }

                        </ButtonBase>
                    ) :
                    (
                        <ButtonBase
                            style={{ borderRadius: "1", margin: 0, padding: 0, alignContent: "center" }}
                        >
                            {
                                <img
                                    src={`data:image/jpeg;base64,${inv.qr_image}`}
                                    style={{ height: "45mm", width: "45mm" }}
                                />
                            }
                        </ButtonBase>
                    )}

            </Grid>}
            <Grid item xs={12}>
                {sta?.tot?.sales_emp_name}
            </Grid>
            {(found.BillNotes != "...." && found.BillNotes != null && found.BillNotes != "")
                && (
                    <Grid
                        item
                        container
                        xs={12}
                        style={{
                            whiteSpace: 'pre-wrap',
                            overflowWrap: 'break-word',
                            fontWeight: "bold",
                            direction: "rtl",
                            fontFamily: "Amiri-Regular",
                            textAlign: "right"
                        }}
                    >
                        {found.BillNotes}
                    </Grid>
                )}
        </Grid>
    );
}

export default TotalsCashair;
